import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('tournament_name_required'),
  start: Yup.date()
    .typeError('invalid_date')
    .max(Yup.ref('end'), 'start_date_same_or_before_than_end_date')
    .required('start_date_required'),
  end: Yup.date()
    .typeError('invalid_date')
    .min(Yup.ref('start'), 'end_date_same_or_later_than_start_date')
    .required('end_date_required'),
  rank: Yup.string().required('tournament_rank_required'),
  category: Yup.string().required('tournament_category_required'),
});
